import API from '@/views/Fdc/Apis/'
import _ from 'lodash'
// import { mapGetters } from 'vuex'

/**
 * Data Collection > Event Collection Plan
 * Event Collection Plan 관리
 */
export default {
  name: 'EventCollectionPlan',
  computed: {
    // ...mapGetters([
    //   'user',
    //   'authed'
    // ])
  },
  beforeMount () {
    this.initDCPlanGridColumns()
    this.initEqpEventColumns()
    this.initDCEventColumns()
  },
  mounted () {
    /**
     * Data Collection Plan에서 화면 연동 시 데이터 처리
     */
    let params = this.$route.query

    if (params.fab && params.eqpId && params.planName) {
      this.nodeObj = this.$route.query
      // this.selectedTreeNode.detail = params
      this.searchTreeNode.detail = params
      this.searchToLink(params.fab, params.eqpId, params.planName)
    }
  },
  methods: {
    /**
     * Data Collection Plan Grid 초기화
     */
    initDCPlanGridColumns () {
      // this.dcPlanGrid = grid
      // grid.itemsSourceChanged.addHandler((s, e) => {
      //   if (s.rows.length > 0) {
      //     this.dcSelRowIdx = 0
      //     this.searchSubPlanList(this.selectedTreeNode.detail.fab, this.selectedTreeNode.detail.eqpId, s.selectedItems[0].planName)
      //   }
      // })
      this.dcColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.PLAN_NAME'), field: 'planName', width: 150 },
        { headerName: this.$t('fdc.COMMON.COLUMN.USABLE'), field: 'useYn', width: 80 },
        { headerName: this.$t('fdc.COMMON.COLUMN.IDLE_APPLY'), field: 'idleApplyYn', width: 120 },
        { headerName: this.$t('fdc.COMMON.COLUMN.LOT_TIMEOUT'), field: 'lotTimeout', width: 120, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.SUBST_TIMEOUT'), field: 'substTimeout', width: 130, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.TRACE_TIMEOUT'), field: 'traceTimeout', width: 130, type: 'numericColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.TARGET'), field: 'targetId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.SOURCE'), field: 'sourceId', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.TARGET_URL'), field: 'targetUrl', width: 150, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EVENT_CMD'), field: 'eventCmd', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.TRACE_CMD'), field: 'traceCmd', width: 100 },
        { headerName: this.$t('fdc.COMMON.COLUMN.REQUEST_URL'), field: 'requestUrl', width: 150, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.REPLY_URL'), field: 'replyUrl', width: 150, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 180, type: 'dateTimeColumn' },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 110 }
      ]
    },
    /**
     * EQP Event Grid 초기화
     */
    initEqpEventColumns () {
      this.eqpEventColumns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.CEID'), field: 'ceid', width: 120, checkboxSelection: true, headerCheckboxSelection: true, sort: 'asc' },
        { headerName: this.$t('fdc.COMMON.COLUMN.EVENT_TYPE'), field: 'eventType', width: 200 },
        { headerName: this.$t('fdc.COMMON.COLUMN.EVENT_NAME'), field: 'eventName', width: 200 },
        { headerName: this.$t('fdc.COMMON.COLUMN.EVENT_DESC'), field: 'eventDesc', width: 250 },
        { headerName: 'id', field: 'id', hide: true }
      ]
    },
    /**
     * Event Collection Plan Grid 초기화
     */
    initDCEventColumns () {
      this.dcEventColumns = [
        { headerName: 'CEID', field: 'ceid', width: 120, checkboxSelection: true, headerCheckboxSelection: true, sort: 'asc' }
      ]
    },
    /**
     * EQP Tree select시 수행하는 method
     * @param {Object} node 선택된 tree node data
     */
    eqpTreeSelected (node) {
      this.selectedTreeNode = node
    },
    /**
     * 원활한 ag-grid 사용을 위해 id를 rowNodeId로 반환함
     * @param {Object} data
     */
    getRowNodeId (data) {
      return data.id
    },
    /**
     * Event Collection Plan 재조회
     */
    refreshEventPlanGrid () {
      this.initEventData()
      if (this.searchTreeNode) {
        let selectEqpVo = this.searchTreeNode.detail
        const planGridCheckedRows = this.$refs.dcPlanGrid.getCheckedRows()
        if (planGridCheckedRows.length > 0 && planGridCheckedRows[0].planName != null) {
          this.searchSubPlanList(selectEqpVo.fab, selectEqpVo.eqpId, planGridCheckedRows[0].planName)
        }
      }
    },
    /**
     * Initialize event data
     */
    initEventData () {
      this.eqpEventRowData = []
      this.eqpEventOrgRowData = []
      this.dcEventRowData = []
      this.dcEventOrgRowData = []
    },
    /**
     * Data Collection Plan Grid row select method
     * @param {*} params
     */
    dataPlanGridRowClicked (params) {
      const { fab, eqpId, planName } = params.data
      if (fab && eqpId && planName) {
        this.initEventData()

        this.searchSubPlanList(fab, eqpId, planName)
      }
    },
    dcPlanGridSelected (grid, event) {
      // console.log(event)
      if (grid.selectedItems.length === 1 && this.dcSelRowIdx !== event.row) {
        let node = this.selectedTreeNode
        if (node != null) {
          if (grid.selectedItems[0].planName != null) {
            this.searchSubPlanList(node.detail.fab, node.detail.eqpId, grid.selectedItems[0].planName)
          }
        }
        // 동일한 row에서 다른 컬럼 클릭시에도 이벤트가 발생하므로 아래와 같이 처리해둠. sort?? ㅡㅡ;
        this.dcSelRowIdx = event.row
      }
    },
    /**
     * Data Collection Plan 검색
     */
    searchProcess () {
      this.dcRowData = []
      this.eqpEventRowData = []
      this.eqpEventOrgRowData = []
      this.dcEventRowData = []
      this.dcEventOrgRowData = []
      this.dcSelRowIdx = -1

      if (this.selectedTreeNode.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP ID']))
        return
      }
      let node = this.selectedTreeNode
      if (node.detail.eqpId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP ID']))
        return
      }
      this.searchTreeNode = this.selectedTreeNode

      this.$commonUtil.setStoreEqpTree(
        this.selectedTreeNode,
        this.$refs.fdcEqpTree.treeType
      )

      this.searchDataCollectionPlanList(node.detail.fab, node.detail.eqpId)
    },
    /**
     * Data Collection Plan에서 연동 시 조회하는 method
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     * @param {String} planName Plan Name
     */
    async searchToLink (fab, eqpId, planName) {
      this.dcRowData = []
      this.eqpEventRowData = []
      this.eqpEventOrgRowData = []
      this.dcEventRowData = []
      this.dcEventOrgRowData = []
      this.dcSelRowIdx = -1

      let payload = {
        fab: fab,
        eqpId: eqpId
      }

      API.Collection.getSyncCollectionPlans(payload)
        .then(response => {
          this.dcRowData = response.data

          // this.dcPlanGrid.collectionView.refresh()
          // this.dcPlanGrid.selection = new wjGrid.CellRange(3, 1, 3, 1)
          // this.dcPlanGrid.selectedCells = { row: 1, col: 1, row2: 1, col2: 1 }

          // this.dcPlanGrid.initialItemsSource = true
          // this.dcPlanGrid.itemsSource = this.dcRowData
          // this.dcPlanGrid.collectionView.refresh()

          const findItem = this.dcRowData.find(function (item) { return _.isEqual(item.planName, planName) })
          if (findItem !== null && findItem !== undefined) {
          // const rowIndex = this.dcPlanGrid.collectionView.items.indexOf(findItem)
          // const rowIndex = this.dcRowData.indexOf(findItem)
          // console.log('rowIndex : ', this.dcPlanGrid.collectionView.items.length)

            // selection row

            setTimeout(() => {
            // const rowIndex = this.dcRowData.indexOf(findItem)
              const rowIndex = this.dcPlanGrid.collectionView.items.indexOf(findItem)
              // this.dcPlanGrid.collectionView.refresh()
              this.dcPlanGrid.select(rowIndex, 1)
              // this.dcPlanGrid.setSelection(1, 0, 1, 0)
              // this.dcPlanGrid.selection = new wjGrid.CellRange(1, 0, 1, 0) - O
              this.dcPlanGrid.focus()
            }, 100)
          }
        })
    },
    /**
     * Data Collection Plan 목록 조회
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     */
    async searchDataCollectionPlanList (fab, eqpId) {
      let payload = {
        fab: fab,
        eqpId: eqpId
      }
      let data = await API.Collection.getCollectionPlans(payload)
      this.dcRowData = data
    },
    /**
     * EQP Event 목록 조회, Event Collection Plan 목록 조회
     * @param {String} fab Fab
     * @param {String} eqpId EQP ID
     * @param {String} planName Plan Name
     */
    async searchSubPlanList (fab, eqpId, planName) {
      this.eqpEventRowData = []
      this.eqpEventOrgRowData = []
      this.dcEventRowData = []
      this.dcEventOrgRowData = []

      let payload = {
        fab: fab,
        eqpId: eqpId,
        planName: planName
      }

      let eqpEventData = await API.FdcCollectionPlan.getEqpEventList(payload)
      this.eqpEventRowData = _.clone(eqpEventData)
      this.eqpEventOrgRowData = _.clone(eqpEventData)

      let dcEventData = await API.Collection.getEventPlans(payload)
      this.dcEventRowData = _.clone(dcEventData)
      this.dcEventOrgRowData = _.clone(dcEventData)
      this.syncGridViews()
      // this.eqpEventGrid.collectionView.refresh()
      // this.dcEventGrid.collectionView.refresh()
    },
    /**
     * CEID 목록 조정
     * Event Collection Plan에 저장된 CEID는 EQP Event 목록에서 보이지 않도록 설정합니다.
     */
    syncGridViews () {
      if (this.dcEventRowData.length > 0) {
        this.dcEventRowData.forEach(row => {
          this.delEqpEventCeid(row.ceid)
          /* eqpEventRows.some(element => {
            console.log(dcRow.dataItem.ceid, element.dataItem.ceid)
            if (_.isEqual(dcRow.ceid, element.ceid)) {
              element.visible = false
            }
          }) */
        })
      }
    },
    /**
     * Data Collection Plan Grid에 check된 row count 확인
     * @returns {*} check된 row가 있는지 여부
     */
    hasCheckedDCPlanRows () {
      if (!this.$refs.dcPlanGrid) {
        return 0
      }
      return this.$refs.dcPlanGrid.checkedRowCount > 0
    },
    /**
     * EQP Event Grid에 check된 row count 확인
     * @returns {*} check된 row가 있는지 여부
     */
    hasCheckedEqpEventRows () {
      if (!this.$refs.eqpEventGrid) {
        return 0
      }
      return this.$refs.eqpEventGrid.checkedRowCount > 0
    },
    /**
     * Event Collection Plan에 지정된 ceid에 대한 grid에 check된 row count 확인
     * @returns {*} check된 row가 있는지 여부
     */
    hasCheckedDCEventRows () {
      if (!this.$refs.dcEventGrid) {
        return 0
      }
      return this.$refs.dcEventGrid.checkedRowCount > 0
    },
    /**
     * Refresh Button 활성화 여부 결정
     * @returns {Boolean} Refresh Button 활성화 여부
     * 검색된 tree node 있는지 여부를 판단하여 Refresh Button 활성화 여부를 결정합니다.
     */
    existRowsDCPlan () {
      if (!this.searchTreeNode.detail) {
        return false
      } else {
        let selectEqpVo = this.searchTreeNode.detail
        if (selectEqpVo.fab !== null && selectEqpVo.eqpId !== null && this.$refs.dcPlanGrid.getCheckedRows().length > 0) {
          return true
        }
        return false
      }
    },
    /**
     * Save Button 활성화 여부 결정
     * @returns {Boolean} Save Button 활성화 여부
     * 검색된 tree node 있는지 여부를 판단하여 Save Button 활성화 여부를 결정합니다.
     */
    existDCEvent () {
      if (!this.existRowsDCPlan()) {
        return false
      } else {
        if (this.dcEventOrgRowData.length === 0 && this.$refs.dcEventGrid.getAllRows().length <= 0) {
          return false
        }
      }
      return true
    },
    /**
     * ceid 존재 여부 체크
     * @param {String} ceid event ceid
     * Event Collection Plan에 ceid 추가 등록 시 동일 ceid가 존재하는지 여부를 확인합니다.
     */
    existDCEventRowData (ceid) {
      if (this.dcEventRowData.length === 0) {
        return false
      }

      let bResult = false

      for (let i = 0; i < this.dcEventRowData.length; i++) {
        if (_.isEqual(this.dcEventRowData[i].ceid, ceid)) {
          bResult = true
          break
        }
      }
      return bResult
    },
    /**
     * ceid 추가 등록
     * Event Collection Plan에 ceid를 추가 등록합니다.
     */
    addDCEventCeid () {
      let selectEqpVo = this.searchTreeNode.detail
      const planGridCheckedRows = this.$refs.dcPlanGrid.getCheckedRows()
      if (selectEqpVo && planGridCheckedRows[0].planName != null) {
        let eqpEventListCheckedRows = this.$refs.eqpEventGrid.getCheckedRows()

        if (eqpEventListCheckedRows.length < 1) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
          return
        }

        eqpEventListCheckedRows.some((row, index) => {
          if (this.existDCEventRowData(row.cied) === false) {
            // 선택된 eqp param grid의 데이터 중에서 DC Trace grid에 없는 것만 추가한다.
            const addItem = {
              fab: selectEqpVo.fab,
              eqpId: selectEqpVo.eqpId,
              planName: this.$refs.dcPlanGrid.getCheckedRows()[0].planName,
              ceid: row.ceid
            }
            this.$refs.dcEventGrid.addRowOne(addItem)
            this.delEqpEventCeid(row.ceid)
          }
        })
        /**
         * NOTE:
         * Arrow right 버튼이 disabled 속성 업데이트가 안되는 상황발생
         * 데이터를 넘긴후 hasCheckedEqpParamRows 함수가 호출이 안됨
         * 아래와 같은 방법으로 ag-grid도 업데이트 해줌
         */
        this.$refs.eqpEventGrid.onClickRemoveRow()
      }
    },
    _addDCEventCeid () {
      let selectEqpVo = this.searchTreeNode.detail
      if (selectEqpVo !== null && this.dcPlanGrid.selectedItems[0].planName != null) {
        let checkedRows = this.$refs.eqpEventGrid.checkedRows

        if (checkedRows < 1) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
          return
        }
        checkedRows.some(row => {
          if (this.existDCEventRowData(row.ceid) === false) {
            // 선택된 eqp event grid의 데이터 중에서 DC Event grid에 없는 것만 추가한다.
            const addItem = [
              {
                fab: selectEqpVo.fab,
                eqpId: selectEqpVo.eqpId,
                planName: this.dcPlanGrid.selectedItems[0].planName,
                ceid: row.ceid
                // vidList: ''
                // createUser: this.user.userId,
                // modifyUser: this.user.userId,
                // isNew: true
              }
            ]
            // DC Event Grid에 추가
            this.$refs.dcEventGrid.addRows(addItem)
            // Eqp Event Grid에서 삭제
            this.delEqpEventCeid(row.ceid)
          }
        })

        // console.log('addRows : ', addRows)
        // this.$refs.dcEventGrid.addRows(addRows)

        /* this.eqpEventRowData.forEach(row => {
          row['_status'].checked = false
        }) */

        this.eqpEventGrid.collectionView.refresh()
        this.dcEventGrid.collectionView.refresh()
      }
    },
    /**
     * ceid 삭제
     * Event Collection Plan에 ceid를 삭제합니다.
     */
    delDCEventCeid () {
      let selectEqpVo = this.searchTreeNode.detail
      const planGridCheckedRows = this.$refs.dcPlanGrid.getCheckedRows()
      if (selectEqpVo !== null && planGridCheckedRows[0].planName != null) {
        let dcEventListCheckedRows = this.$refs.dcEventGrid.getCheckedRows()

        if (dcEventListCheckedRows < 1) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED', ['Item']))
          return
        }

        dcEventListCheckedRows.some(row => {
          this.addEqpEventCeid(row.ceid)
        })

        this.$refs.dcEventGrid.onClickRemoveRow()
      }
    },
    _delDCEventCeid () {
      let selectEqpVo = this.searchTreeNode.detail
      if (selectEqpVo !== null && this.dcPlanGrid.selectedItems[0].planName != null) {
        let checkedRows = this.$refs.dcEventGrid.checkedRows

        if (checkedRows < 1) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED', ['Item']))
          return
        }

        checkedRows.some(row => {
          for (let i = this.dcEventRowData.length - 1; i >= 0; i--) {
            if (_.isEqual(this.dcEventRowData[i].ceid, row.ceid)) {
              this.dcEventRowData.splice(i, 1)
              this.addEqpEventCeid(row.ceid)
            }
          }
        })

        this.dcEventGrid.collectionView.refresh()
        this.eqpEventGrid.collectionView.refresh()
      }
    },
    /**
     * CEID 목록 제거 (EQP Event Grid)
     * Event Collection Plan에 저장된 CEID는 EQP Event 목록에서 보이지 않도록 설정합니다.
     */
    delEqpEventCeid (ceid) {
      // EqpEventRowData에서 삭제
      const findItem = this.eqpEventRowData.find(function (item) { return _.isEqual(item.ceid, ceid) })
      if (findItem === null || findItem === undefined) {
        return
      }
      const index = this.eqpEventRowData.indexOf(findItem)
      if (index >= 0) {
        this.eqpEventRowData.splice(index, 1)
      }
    },
    /**
     * CEID 목록 추가 (EQP Event Grid)
     * Event Collection Plan에 저장되지 않은 CEID는 EQP Event 목록에서 보여지도록 설정합니다.
     */
    addEqpEventCeid (ceid) {
      // EqpEventRowData <- EqpEventOrgRowData에서 ceid가 동일한 Row를 추가
      const findItem = this.eqpEventOrgRowData.find(function (item) { return _.isEqual(item.ceid, ceid) })
      const index = this.eqpEventOrgRowData.indexOf(findItem)
      if (index >= 0) {
        this.eqpEventRowData.splice(this.eqpEventRowData.length, 0, _.clone(findItem))
      }
    },
    /**
     * Event Collection Plan 저장
     */
    async saveEventPlan () {
      const planGridCheckedRows = this.$refs.dcPlanGrid.getCheckedRows()
      if (planGridCheckedRows.length < 1) {
        return
      }
      let node = this.selectedTreeNode
      if (node == null) {
        return
      }

      const self = this
      const allRows = this.$refs.dcEventGrid.getAllRows()
      // const checkedRows = this.$refs.dcEventGrid.checkedRows
      // const totalModifiedRows = this.$refs.dcEventGrid.totalModifiedRows
      let saveRows = []
      let payload

      // 일단 무조건 저장!!
      // console.log(allRows)

      let isOnlyDelete = false
      if (allRows.length <= 0) {
        if (this.dcEventOrgRowData.length >= 0 && planGridCheckedRows[0].planName != null) {
          isOnlyDelete = true
          payload = {
            fab: node.detail.fab,
            eqpId: node.detail.eqpId,
            planName: planGridCheckedRows[0].planName
          }
        } else {
          // 변경된 데이터가 없는 경우....NOT_CHANGED: 'Not changed Items'
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_CHANGED'))
          return
        }
      } else {
        allRows.some(row => {
          const item = _.clone(row)
          saveRows.push(item)
        })
        payload = saveRows
      }

      let confirmMessage = ''
      const successMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE')
      const failMessage = this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE')
      confirmMessage += this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

      if (this.saveValidationCheck(saveRows) === false) {
        return
      }

      this.$dialog.confirm({
        message: confirmMessage,
        onConfirm: async function () {
          let responseData
          if (isOnlyDelete === true) {
            responseData = await API.FdcCollectionPlan.deleteEventCollectionPlan(payload)
          } else {
            responseData = await API.FdcCollectionPlan.saveEventCollectionPlan(payload)
          }
          if (responseData != null && responseData.status === 200) {
            self.$dialog.alert(successMessage)

            // self.dcEventRowData.forEach(row => {
            //   row['_status'].added = false
            //   row['_status'].checked = false
            //   row['_status'].modified = false
            // })
            // self.dcEventGrid.collectionView.refresh()
            // self.eqpEventGrid.collectionView.refresh()
          } else {
            self.$dialog.alert(failMessage)
          }
        }
      })
    },
    async _saveEventPlan () {
      if (this.dcPlanGrid.selectedItems.length < 1) {
        return
      }
      let node = this.selectedTreeNode
      if (node == null) {
        return
      }

      const self = this
      const allRows = this.$refs.dcEventGrid.rows
      // const checkedRows = this.$refs.dcEventGrid.checkedRows
      // const totalModifiedRows = this.$refs.dcEventGrid.totalModifiedRows
      let saveRows = []
      let payload

      // 일단 무조건 저장!!
      // console.log(allRows)

      let isOnlyDelete = false
      if (allRows.length <= 0) {
        if (this.dcEventOrgRowData.length >= 0 && this.dcPlanGrid.selectedItems[0].planName != null) {
          isOnlyDelete = true
          payload = {
            fab: node.detail.fab,
            eqpId: node.detail.eqpId,
            planName: this.dcPlanGrid.selectedItems[0].planName
          }
        } else {
          // 변경된 데이터가 없는 경우....NOT_CHANGED: 'Not changed Items'
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_CHANGED'))
          return
        }
      } else {
        allRows.some(row => {
          const item = _.clone(row.dataItem)
          delete item['_status']
          saveRows.push(item)
        })
        payload = saveRows
      }

      let confirmMessage = ''
      const successMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE')
      const failMessage = this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE')
      /* if (!_.isEqual(saveRows.length, totalModifiedRows.length)) {
        confirmMessage = this.$t('fdc.FDC_DATA_COLLECTION.DIALOG.CONFIRM.CHANGES_UNCHECKED')
      } */
      confirmMessage += this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

      if (this.saveValidationCheck(saveRows) === false) {
        return
      }

      this.$dialog.confirm({
        message: confirmMessage,
        onConfirm: async function () {
          let responseData
          if (isOnlyDelete === true) {
            responseData = await API.FdcCollectionPlan.deleteEventCollectionPlan(payload)
          } else {
            responseData = await API.FdcCollectionPlan.saveEventCollectionPlan(payload)
          }
          if (responseData != null && responseData.status === 200) {
            self.$dialog.alert(successMessage)
            // console.log(responseData)
            // console.log(self.dcEventRowData)
            self.dcEventRowData.forEach(row => {
              row['_status'].added = false
              row['_status'].checked = false
              row['_status'].modified = false
            })
            self.dcEventGrid.collectionView.refresh()
            self.eqpEventGrid.collectionView.refresh()
          } else {
            self.$dialog.alert(failMessage)
          }
        }
        // onCancel: function () {}
      })
    },
    /**
     * Event Collection Plan Save Validation
     * @param {Array} rows grid row 배열
     * @returns {Boolean} validation 성공 여부
     */
    saveValidationCheck (rows) {
      for (let i in rows) {
        if (!rows[i].fab || rows[i].fab.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['FAB']))
          return false
        } else if (!rows[i].eqpId || rows[i].eqpId.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['EQP ID']))
          return false
        } else if (!rows[i].planName || rows[i].planName.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['PLAN NAME']))
          return false
        } else if (!rows[i].ceid || rows[i].ceid.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['CEID']))
        }
      }
      return true
    }
  },
  data () {
    return {
      dcColumns: [], // Data Collection Plan grid column 배열
      eqpEventColumns: [], // EQP Event grid column 배열
      dcEventColumns: [], // Event Collection Plan에 등록된 CEID grid column 배열
      dcRowData: [], // Data Collection Plan row data
      dcSelRowIdx: -1, // Data Collection Plan 선택된 row index
      eqpEventRowData: [], // EQP Event row data
      eqpEventOrgRowData: [], //  EQP Event row data (수정 전)
      dcEventRowData: [], // Event Collection Plan에 등록된 CEID row data
      dcEventOrgRowData: [], // Event Collection Plan에 등록된 CEID row data (수정 전)
      selectedTreeNode: [], // 선택된 EQP Tree node
      searchTreeNode: [], // 검색한 EQP Tree node
      collectionViewOptions: {
        sortDescriptions: ['ceid']
      }, // grid collectionView Option
      nodeObj: null, // Data Collection Plan에서 화면 연동시 저장된 EQP Tree node 정보
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true
      }
    }
  }
}
